import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { ICustomFormProps } from "../interfaces/form";
import {
  CustomCheckboxField,
  CustomDatePickerField,
  CustomMultiSelectChipsField,
  CustomRadioField,
  CustomSelectField,
  CustomSwitchField,
  CustomTextField,
} from "./CustomFields";

const CustomForm: FC<ICustomFormProps> = (props: ICustomFormProps) => {
  const {
    initialValues,
    inputs,
    submit,
    validationSchema,
    titleForm,
    customStyles,
    labelButtonSubmit,
    isDialog
  } = props;

  const formMethods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { ...(initialValues as any) },
  });
  const { register, unregister, watch } = formMethods;
  const watchBeehiveAssigned = watch("beehiveAssigned");
  const [showAreaField, setShowAreaField] = useState(false);

  useEffect(() => {
    if (watchBeehiveAssigned) {
      setShowAreaField(true);
      register("areaId");
    } else {
      setShowAreaField(false);
      unregister("areaId");
    }
  }, [register, unregister, watchBeehiveAssigned]);

  const renderInputs = () =>
    inputs.map(({ validations, value, ...inputProps }) => {
      const allInputProps = { ...inputProps, register }
      switch (inputProps.type) {
        case "select":
          if (watchBeehiveAssigned === undefined || watchBeehiveAssigned && showAreaField)
            return (
              <CustomSelectField key={inputProps.name} {...allInputProps} />
            );
          else
            return;
        case "checkbox":
          return (
            <CustomCheckboxField key={inputProps.name} {...allInputProps} />
          );
        case "radio":
          return (
            <CustomRadioField key={inputProps.name} {...allInputProps} />
          );
        case "datepicker":
          return (
            <CustomDatePickerField key={inputProps.name} {...allInputProps} />
          )
        case "switch":
          return (
            <CustomSwitchField key={inputProps.name} {...allInputProps} />
          )
        case "multiselect-chips":
          return (
            <CustomMultiSelectChipsField key={inputProps.name} {...allInputProps} />
          );
        default:
          return (
            <CustomTextField key={inputProps.name} {...allInputProps} />
          );
      }
    });

  return isDialog === false ?
    <FormProvider {...formMethods}>
      {titleForm && <Typography variant="h5">{titleForm}</Typography>}
      <form onSubmit={formMethods.handleSubmit(submit)}>
        <Box sx={customStyles}>{renderInputs()}</Box>
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 1 }}
            type="submit"
          >
            {labelButtonSubmit}
          </Button>
        </Box>
      </form>
    </FormProvider>
    :
    <Box sx={customStyles}>{renderInputs()}</Box>;
};

export default CustomForm;
